import { load } from "@fingerprintjs/botd";

const botDetection: ReturnType<typeof load> = load();
const isProbablyBot = async () => {
    const bd = await botDetection;
    return window?.location?.href?.includes("bd=true") || bd.detect().bot;
};

export { isProbablyBot };
